class NaptonHolidayScene extends HTMLElement {
  connectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
    this.querySelectorAll('[data-scene-choice]').forEach(button => button.disabled = false);
    this.inView = false;
    this.addEventListener('click', event => {
      const choice = event.target.closest('[data-scene-choice]');
      if (choice) {
        this.dataset.mood = choice.dataset.sceneChoice;
        this.querySelectorAll('[data-scene-choice]').forEach(button => button.setAttribute('aria-pressed', String(button === choice)));
        this.querySelector('[data-mood-copy]').textContent = choice.dataset.copy;
        this.querySelector('[data-mood-title]').textContent = choice.dataset.title;
        this.querySelectorAll('[data-scene-photo]').forEach(photo => photo.hidden = photo.dataset.scenePhoto !== choice.dataset.sceneChoice);
        const link = this.querySelector('[data-mood-link]');
        link.href = choice.dataset.link;
        link.firstChild.textContent = choice.dataset.linkLabel + ' ';
      }
    }, { signal });
    this.reduced.addEventListener('change', () => {
      this.syncMotion();
    }, { signal });
    document.addEventListener('visibilitychange', () => this.syncMotion(), { signal });
    if ('IntersectionObserver' in window) {
      this.observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          this.inView = entry.isIntersecting;
          if (this.inView) this.classList.add('nhx-arrived');
          this.syncMotion();
        });
      }, { threshold: .12 });
      this.observer.observe(this);
    } else {
      this.inView = true;
      this.syncMotion();
    }
  }
  syncMotion() {
    this.classList.toggle('nhx-playing', this.inView && !this.reduced.matches && !document.hidden);
  }
  disconnectedCallback() {
    this.controller?.abort();
    this.observer?.disconnect();
  }
}
if (!customElements.get('napton-holiday-scene')) customElements.define('napton-holiday-scene', NaptonHolidayScene);

